import { useQuery } from '@tanstack/react-query';

import { erpApi } from '@/shared/axios/erp-api';
import { urlBackend } from '@/shared/constants';
import { ReporteUsuariosResponse } from '../interfaces/reporte-usuarios.interface';

const { get } = erpApi();

export enum ReporteUsuariosQueryKeys {
  REPORTE_USUARIOS_COMPLETO = 'reporte-usuarios-completo',
}

export const getReporteUsuariosCompleto = () => {
  return get<ReporteUsuariosResponse['data']>(
    `${urlBackend}api/v1/reporte-usuarios/`,
    true,
  );
};

export const useFetchReporteUsuariosCompleto = (enabled = true) => {
  return useQuery({
    queryKey: [ReporteUsuariosQueryKeys.REPORTE_USUARIOS_COMPLETO],
    queryFn: () => getReporteUsuariosCompleto(),
    enabled,
    staleTime: 60_000,
  });
};
